import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import PortfolioForm from '../../../../components/PortfolioForm';
import FilingListGrid from '../../../../components/FilingListGrid';
import SalesPanel from '../../../../components/SalesPanel';
import SalesListGrid from '../../../../components/SalesListGrid';
import AdvancedSalesListGrid from '../../../../components/AdvancedSalesListGrid';
import HistoryGrid from '../../components/HistoryGrid';

import {
    fetchFundTypes,
    fetchStates,
    fetchCountries
} from '../../../../../../services/redux/commonData/actions';
import {
    updatePortfolioHistoryItemSelected,
    handleViewPortfolioVisibility,
    handleEditPortfolioVisibility,
    fetchPortfolioSales,
    fetchPortfolioAdminSales,
    fetchPortfolioFilings
} from '../../../../../../services/redux/employee/portfolio/actions';
import { fetchTrustData } from '../../../../../../services/redux/employee/trust/actions';
import {
    fetchFilingById,
    updateFilingInfoData,
    fetchClientData,
    fetchStateData
} from '../../../../../../services/redux/employee/filing/actions';

class ViewPortfolio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1
        };
    }
    componentDidMount() {
        let { fetchFundTypes, fetchStates, fetchCountries } = this.props;
        fetchFundTypes();
        fetchStates();
        fetchCountries();
    }
    onEditClick = () => {
        let {
            handleViewPortfolioVisibility,
            handleEditPortfolioVisibility
        } = this.props;
        handleViewPortfolioVisibility(false);
        handleEditPortfolioVisibility(true);
    };
    onBackClick = () => {
        let { handleViewPortfolioVisibility, location, history } = this.props;
        if (location.from && location.from !== '/client-details') {
            history.push({
                pathname: location.from,
                from: '/client-details'
            });
        } else {
            handleViewPortfolioVisibility(false);
        }
    };

    onViewSalesClick = (startDate, endDate, state = '') => {
        let { portfolio, fetchPortfolioSales } = this.props;
        fetchPortfolioSales({
            portfolioId: portfolio.viewPortfolio.portfolioId,
            startDate,
            endDate,
            state
        });
    };

    onViewAdvancedSalesClick = (startDate, endDate, state = '') => {
        let { portfolio, fetchPortfolioAdminSales } = this.props;
        fetchPortfolioAdminSales({
            portfolioId: portfolio.viewPortfolio.portfolioId,
            startDate,
            endDate,
            state
        });
    };

    onChangeTab = key => {
        this.setState({ activeTab: key });
    };

    reviewPendingFiling = data => {
        let {
            history,
            portfolio,
            fetchFilingById,
            fetchClientData,
            fetchStateData,
            fetchTrustData,
            updateFilingInfoData
        } = this.props;

        fetchFilingById(data.filingId).then(response => {
            if (response) {
                fetchClientData(response.clientId);
                fetchStateData(response.stateId);
            }
        });

        let filingInfoData = data;
        fetchTrustData(portfolio.editPortfolio.trustId).then(resp => {
            if (resp && resp.name) {
                filingInfoData = { ...filingInfoData, trustName: resp.name };
            }
            updateFilingInfoData({
                ...filingInfoData,
                portfolioName: portfolio.editPortfolio.name
            });
        });

        history.push({ pathname: '/filing-details', from: '/client-details' });
    };

    render() {
        let {
            portfolio,
            commonData,
            roleName,
            updatePortfolioHistoryItemSelected
        } = this.props;
        let { activeTab } = this.state;
        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );
        let editButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onEditClick}
            >
                Edit
            </button>
        );
        return (
            <div className="panel">
                <Tabs
                    id="tabID"
                    onSelect={this.onChangeTab}
                    activeKey={this.state.activeTab}
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab eventKey={1} title="View Portfolio">
                        <Panel>
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <PortfolioForm
                                    portfolioData={portfolio.editPortfolio}
                                    parentTrusts={portfolio.parentTrusts}
                                    fundTypeList={commonData.fundTypes}
                                    countryList={commonData.countries}
                                    stateList={commonData.states}
                                    isEditable={false}
                                />
                            </div>
                        </Panel>
                    </Tab>
                    <Tab eventKey={2} title="Filings">
                        <FilingListGrid
                            dataList={portfolio.filings}
                            handleReviewButtonClick={this.reviewPendingFiling}
                        />
                    </Tab>
                    <Tab eventKey={3} title="Sales">
                        <SalesPanel
                            onViewClick={this.onViewSalesClick}
                            stateList={commonData.states}
                        />
                        <SalesListGrid dataList={portfolio.sales} />
                    </Tab>
                    {(roleName === 'Administrator' ||
                        roleName === 'Superuser') && (
                        <Tab eventKey={4} title="Advanced Sales">
                            <SalesPanel
                                onViewClick={this.onViewAdvancedSalesClick}
                                stateList={commonData.states}
                            />
                            <AdvancedSalesListGrid
                                dataList={portfolio.adminSales}
                            />
                        </Tab>
                    )}
                    <Tab eventKey={5} title="Change Log">
                        <HistoryGrid
                            dataList={portfolio.history}
                            updateSelected={updatePortfolioHistoryItemSelected}
                        />
                        {portfolio.selectedHistoryItem &&
                            portfolio.selectedHistoryItem.portfolioId && (
                                <Panel
                                    showHeader
                                    header="History Item Details"
                                    panelStyle="panel-default m0"
                                >
                                    <div className="col-lg-6 col-md-8 col-sm-12">
                                        <PortfolioForm
                                            portfolioData={
                                                portfolio.selectedHistoryItem
                                            }
                                            parentTrusts={
                                                portfolio.parentTrusts
                                            }
                                            isEditable={false}
                                        />
                                    </div>
                                </Panel>
                            )}
                    </Tab>
                    <br />
                    {activeTab === 1 && editButton}
                    {backButton}
                </Tabs>
                {portfolio.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    portfolio: state.employee.portfolio,
    commonData: state.commonData,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updatePortfolioHistoryItemSelected,
            handleViewPortfolioVisibility,
            handleEditPortfolioVisibility,
            fetchPortfolioSales,
            fetchPortfolioAdminSales,
            fetchFundTypes,
            fetchStates,
            fetchCountries,
            fetchPortfolioFilings,
            fetchFilingById,
            updateFilingInfoData,
            fetchClientData,
            fetchStateData,
            fetchTrustData
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ViewPortfolio));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/screens/ViewPortfolio/index.js